import { lazy } from 'react';

const DashboardPage = lazy(() => import('./components/DashboardPage'));

const DashboardConfig = {
    settings: {
        layout: {
            config: {},
        },
    },
    routes: [
        {
            path: 'salesDashboard',
            element: <DashboardPage />,
        },
    ],
};

export default DashboardConfig;